export default "__VITE_ASSET__DirdfBzn__"